export enum PromoCodeDiscountStatus {
  NOT_SET = 0,
  UPCOMING = 1,
  ACTIVE = 2,
  EXPIRED = 3,
}
